import React from 'react'
import './Style/Footer.css'
function Footer({info,todayDate}) {
  return <div className='footer'>

    <div className='footer-info'>
      <div>
        <h1>  Terms & Conditions  </h1>
        <p className='conditions'> Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex voluptas cum fugit nostrum amet omnis tempora quasi illum aliquam. Maxime harum ex, adipisci dignissimos quaerat iure consequuntur illum cupiditate autem. </p>
        <p className='thanks'> Thank you For Your Business </p>
      </div>
      <div>
        <h1 className='Manager'> Company Manager </h1>
        <p className='Manager-name'> {info.info.managerName}</p>
      </div>
    </div>

    <div className='btnfooter'> <span className='todayDate'>{todayDate}</span> </div>

  </div>
}

export default Footer